import React from "react";
import { Link } from "react-router-dom";

export default function RegisterCallout({ className }) {
  return (
    <section
      id="register"
      class={`bg-sunny-top-left ${className} register-callout`}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-9 text-center">
            <div style={{ maxWidth: "60em", display: "inline-block" }}>
              <h3 className="color-white pb-4">
                Don’t miss the country’s{" "}
                <span className="color-yellow">
                  most comprehensive compensation conference
                </span>{" "}
                for banks and <span className="nobr">credit unions</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row align-items-center justify-content-center">
          <div className="col-12 text-center">
            <Link to="/Registration" className="btn-white-o mx-3 mb-4 mb-lg-0">
              Register Now <i className="ms-2 fa fa-arrow-right"></i>
            </Link>
            <Link
              to="/SponsorForm"
              className="btn-white-o mx-3 mb-4 mb-lg-0"
              // className="btn-white-o mx-3"
            >
              Become a Sponsor <i className="ms-2 fa fa-arrow-right"></i>
            </Link>

            {/* <a
              href="mailto:[Boss’s Email]?subject=FinComp%202025%20%E2%80%93%20Conference%20Request&body=Hi%20%5BBoss%E2%80%99s%20Name%5D%2C%0A%0AI%E2%80%99m%20reaching%20out%20to%20see%20if%20you%E2%80%99d%20consider%20approving%20my%20attendance%20at%20a%20conference%20I%20found%20called%20FinComp%20(http%3A%2F%2Ffincomp.balancedcomp.com)%2C%20the%20nation%E2%80%99s%20only%20compensation%20conference%20exclusively%20for%20financial%20institutions.%20It%E2%80%99s%20happening%20September%207%E2%80%9310%20in%20San%20Diego%20and%20focuses%20explicitly%20on%20compensation%2C%20pay%20transparency%2C%20and%20HR%20strategy%20for%20banks%20and%20credit%20unions.%0A%0AA%20few%20of%20the%20sessions%20(http%3A%2F%2Ffincomp.balancedcomp.com%2Fagenda)%20look%20especially%20relevant%20right%20now%2C%20like%20%5Binsert%20session%20name%5D%20and%20%5Binsert%20session%20name%5D.%20I%20think%20they%20could%20offer%20practical%2C%20timely%20takeaways%20we%20can%20actually%20use.%20Bonus%3A%20it%E2%80%99s%20fully%20accredited%20for%20SHRM%20and%20HRCI%20credits%2C%20which%20we%20usually%20pay%20extra%20for%20through%20separate%20trainings.%0A%0AHere%E2%80%99s%20the%20estimated%20cost%3A%0A%0A%20%E2%80%A2%20Ticket%3A%20%241%2C995%20%7C%20Group%20discount%20price%3A%20%241%2C495%20(for%20additional%20team%20members)%0A%20%E2%80%A2%20Hotel%3A%20%24329%2Fnight%20%2B%20taxes%0A%20%E2%80%A2%20Travel%2Fper%20diem%3A%20%24%5Binsert%20amount%5D%0A%20%E2%80%A2%20Approx.%20total%3A%20%24%5Binsert%20total%5D%0A%0AIf%20you%E2%80%99re%20open%20to%20it%2C%20I%E2%80%99d%20love%20to%20attend.%20I%E2%80%99ll%20plan%20to%20share%20takeaways%20with%20the%20team%20once%20I%E2%80%99m%20back.%20Let%20me%20know%20what%20you%20think.%0A%0AThanks%2C%0A%5BYour%20Name%5D"
              target="_blank"
              rel="noreferrer"
              className="btn-white-o mx-3"
            >
              Convince Your Boss <i className="ms-2 fa fa-envelope"></i>
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
}
